export const localStorageMap = {
  rightColumnWidth: 'rightColumn.width',
  scenarioLeftSideWidth: 'scenario.leftSide.width',
  updateRequestNotes: 'updateRequest.notes.width',
};
